// extracted by mini-css-extract-plugin
export default {"status":"BTk0d","ok":"viwHK","icon":"t4cyi"};